import COM from './Map'

export default COM
